<div class="cards-wrapper">
    <div class="cards-container">
        <mat-card *ngFor="let card of cards" class="card">
            <mat-card-header>
                <div mat-card-avatar>
                    <div [class]="card.icon" aria-hidden="true"></div>
                </div>
                <mat-card-title>{{ card.title }}</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>
            <mat-card-content>
                <p>{{ card.description }}</p>
            </mat-card-content>

            <mat-card-actions>
                <button mat-button color="primary" class="toolbar-action-btn" (click)="onButtonClick(card.command)">
                    <i class="fa-solid fa-plus"></i> {{ card.buttonText }}
                </button>
            </mat-card-actions>
        </mat-card>
    </div>
</div>
